export enum EndpointContextEnum {
  QUERY = 'query',
  FILTER = 'filter',
}
